const r = (r2 = []) => {
  const t = Array.isArray(r2) ? r2 : [r2], e = new Set(t);
  return (r3) => !e.has(r3);
};
export {
  r as excludeForwardProps
};
//# sourceMappingURL=excludeForwardProps.js.map
